import React, { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import { observer, inject } from "mobx-react";

import FullObjectPane from "./EditObject/FullObjectPane";
import { QuizObject } from "../../../../store/modquiz/quiz_objects/quiz-object";
import SidebarObject from "../../Component/SidebarObject";
import Grid from "@mui/material/Grid";

import "./style.css";

class QuizObjectRoute extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            id: 0,
            saving: false,
            error: false,
            deleteText: "Delete",
            saveText: "Save",
            quizThisCard: false,
            deleteState: false,
            toSubject: false,
            errorTitle: undefined,
            errorMessage: undefined
        };

        this.deleteObject = this.deleteObject.bind(this);
        this.saveObject = this.saveObject.bind(this);

        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleDefinitionChange = this.handleDefinitionChange.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this);
        this.addFact = this.addFact.bind(this);
        this.addList = this.addList.bind(this);
        this.addTable = this.addTable.bind(this);
        this.addCardTable = this.addCardTable.bind(this);
        this.quizThisCard = this.quizThisCard.bind(this);
    }

    componentDidMount() {
        this.fetchObject();
    }

    componentDidUpdate(props: any) {
        if (props.location.pathname !== this.props.location.pathname) {
            this.fetchObject();
        }
    }

    fetchSubject() {
        this.props.rootStore.subjectStore.fetchOne(
            this.props.match.params.subject_user,
            this.props.match.params.subject_slug
        );    
    }

    fetchObject() {
        this.props.rootStore.subjectStore.fetch();
        this.fetchSubject();
        this.props.rootStore.objectStore.fetchByID(
            this.props.match.params.object_id
        );
    }

    saveObject(quizObject: QuizObject) {
        this.setState({
            saving: true
        });
        this.props.rootStore.objectStore.save(
            quizObject,
            (
                errored: boolean,
                errorTitle: string,
                errorMessage: string,
                object: any
            ) => {
                if (errored) {
                    this.setState({
                        saving: false,
                        error: true,
                        saveText: "Error",
                        errorTitle: errorTitle,
                        errorMessage: errorMessage
                    });
                } else {
                    this.setState({
                        saving: false,
                        saveText: "Saved"
                    });
                }
            }
        );
    }

    deleteObject(quizObject: QuizObject) {
        this.setState({
            deleting: true
        });
        this.props.rootStore.objectStore.delete(
            quizObject,
            (errored: boolean, object: any) => {
                if (errored) {
                    this.setState({
                        saving: false,
                        error: true,
                        deleteText: "Error"
                    });
                } else {
                    this.setState({
                        saving: false,
                        deleteText: "Deleted",
                        toSubject: true
                    });
                }
            }
        );
    }

    addList() {
        this.props.rootStore.objectStore.addList(
            this.props.match.params.object_id
        );
        this.setState({
            id: this.state.id + 1
        });
    }

    addTable() {
        this.quiz_object().addTable();
    }

    addFact() {
        this.quiz_object().addFact();
    }

    setTables(tables: Array<any>) {
        this.props.rootStore.objectStore.setTables(
            this.props.match.params.object_id,
            tables
        );
        this.setState({
            id: this.state.id + 1
        });
    }

    addCardTable() {
        this.props.rootStore.objectStore.addCardTable(
            this.props.match.params.object_id,
            this.subject()
        );
        this.setState({
            id: this.state.id + 1
        });
    }

    setCardTables(cardTables: Array<any>) {
        this.props.rootStore.objectStore.setCardTables(
            this.props.match.params.object_id,
            cardTables
        );
        this.setState({
            id: this.state.id + 1
        });
    }

    quizThisCard() {
        this.setState({
            quizThisCard: true
        });
    }

    handleQuizObjectFieldChange(field: string, value: string) {
        this.props.rootStore.objectStore.setQuizObject(
            field,
            this.props.match.params.object_id,
            value
        );
        this.setState({
            id: this.state.id + 1
        });
    }
    handleTitleChange(ev: any) {
        this.handleQuizObjectFieldChange("title", ev.currentTarget.value);
    }

    handleDefinitionChange(ev: any) {
        this.handleQuizObjectFieldChange("definition", ev.currentTarget.value);
    }

    handleNotesChange(ev: any) {
        this.handleQuizObjectFieldChange("notes", ev.currentTarget.value);
    }

    subjectHashKey() {
        let params = this.props.match.params;
        return `${params.subject_user}/${params.subject_slug}`;
    }

    subject = () =>
        this.props.rootStore.subjectStore.subjects.get(
            this.subjectHashKey()
        );

    quiz_objects = () => {
        let subject = this.props.rootStore.subjectStore.subjects.get(
            this.subjectHashKey()
        );

        if (subject) return subject.objects;

        return [];
    };

    quiz_object = () => {
        return this.props.rootStore.objectStore.quiz_objects.get(
            this.props.match.params.object_id
        );
    };

    render() {
        if (!this.subject()) {
            return <div></div>;
        }

        let header: JSX.Element = <div></div>;
        let objectPane: JSX.Element = <div></div>;

        if (this.state.quizThisCard) {
            return (
                <Navigate
                    to={`/quiz/${this.subjectHashKey()}/${this.quiz_object()._id}`}
                />
            );
        }

        if (this.state.toSubject) {
            return <Navigate to={`/subjects/${this.subjectHashKey()}`} />;
        }

        if (this.quiz_object()) {
            objectPane = (
                <FullObjectPane
                    handleDefinitionChange={this.handleDefinitionChange}
                    handleNotesChange={this.handleNotesChange}
                    handleTitleChange={this.handleTitleChange}
                    quiz_object={this.quiz_object()}
                    deleteObject={() => this.deleteObject(this.quiz_object())}
                    saveObject={() => this.saveObject(this.quiz_object())}
                    addFact={this.addFact}
                    addList={this.addList}
                    addTable={this.addTable}
                    addCardTable={this.addCardTable}
                    quizThisCard={this.quizThisCard}
                    setCardTables={this.setCardTables}
                    setTables={this.setTables}
                    deleting={this.state.deleteState}
                    saving={this.quiz_object().saving}
                    saveText={this.quiz_object().saveText}
                    deleteText={this.state.deleteText}
                    errorTitle={this.state.errorTitle}
                    errorMessage={this.state.errorMessage}
                    error={this.state.error}
                    subjectHashKey={this.subjectHashKey()}
                />
            );
        }

        let quizzerLink = <div></div>;

        return (
            <Grid container direction="row">
                <Grid item xs={"auto"} sm={3} md={2}>
                    <SidebarObject
                        location={this.props.location}
                        subjectHashKey={this.subjectHashKey()}
                        subject={this.subject()}
                        hasCreateAccess={
                            this.props.rootStore.profileStore.isLoggedIn
                        }
                        subject_user={this.props.match.params.subject_user}
                        subject_slug={this.props.match.params.subject_slug}
                    />
                </Grid>
                <Grid item xs={12} sm={9} md={10}>
                    {quizzerLink}
                    <div className="quiz-object-edit-container">
                        <div className="Profile">{objectPane}</div>
                    </div>
                </Grid>
            </Grid>
        );
    }
}

export default observer(QuizObjectRoute);
